//
import StateModel from '@/models/General/GState'
import UserModel from '@/models/General/GUser'

//
export default [
    {
        name: 'supervisor_g_user_id',
        props: {
            hideDetails: true,
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Empleado',
            model: UserModel,
            noObject: true,
            paramSearch: 'search',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'g_state_id',
        props: {
            hideDetails: true,
            itemText: 'state',
            itemValue: 'id',
            label: 'Estado',
            model: StateModel,
            noObject: true,
            paramFilter: {
                g_state_type_id: 11,
            },
            paramSearch: 'state',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'dispatched_date',
        picker: {
            //activePicker: "YEAR",
        },
        props: {
            hideDetails: true,
            label: 'Despacho',
        },
        type: 'date-field',
        value: '',
    },
    {
        name: 'billed',
        flex: {
            'pt-2': true,
            'xs12': true,
            'sm2': true,
        },
        props: {
            label: 'Solo Facturadas',
        },
        type: 'switch',
    },
    {
        name: 'zone',
        type: 'text-field',
        props: {
            label: 'Zona',
        },
    },
]
